"use client"

import { Layer } from "effect"
import { AppHttpClient } from "@/shared/scope"
import { RpcClient, RpcSerialization } from "@effect/rpc"
import { createEffectQueryNoAbort } from "@/lib/api/effect-query-utils"
import { FeedSpotlightRpc } from "@/contexts/feed/presentation/feed-spotlight-rpc"

const FeedSpotlightRpcLive = RpcClient.layerProtocolHttp({ url: "/api/rpc/feed-spotlight" }).pipe(
  Layer.provide(AppHttpClient.layer),
  Layer.provideMerge(RpcSerialization.layerJson),
)

export const feedSpotlightEq = createEffectQueryNoAbort(FeedSpotlightRpcLive)
export { FeedSpotlightRpc }
